import React from "react";
import { Button, Modal, notification, Table } from "antd";
import { useMutation } from "@apollo/react-hooks";
import { frGql } from "../../../graphql/fr/organizer";

export const AddAdminDlg = ({ org, funOrg, onClose }) => {
  const [addFrOrganizerAdmin] = useMutation(frGql.addFrOrganizerAdmin);
  const [delFrOrganizerAdmin] = useMutation(frGql.delFrOrganizerAdmin);

  const onAdd = (r) => {
    addFrOrganizerAdmin({
      variables: {
        input: {
          organizerId: funOrg.id,
          orgId: org.id,
          userId: r.teacher.id,
        },
      },
    })
      .then(() => {
        notification.success({ message: `Add admin successed!` });
        onClose(true);
      })
      .catch((err) => {});
  };

  const onDel = (r) => {
    delFrOrganizerAdmin({
      variables: {
        input: {
          organizerId: funOrg.id,
          orgId: org.id,
          userId: r.teacher.id,
        },
      },
    })
      .then(() => {
        notification.success({ message: `Remove admin successed!` });
        onClose(true);
      })
      .catch((err) => {});
  };

  const isAdmin = (r) => {
    console.log(
      funOrg.admins,
      r,
      funOrg.admins.find((x) => x.id === r.teacher.id)
    );
    return !funOrg.admins.find((x) => x.id === r.teacher.id);
  };

  const columns = [
    {
      title: "Full name",
      dataIndex: ["teacher", "name"],
      key: "name",
    },
    {
      title: "Email",
      dataIndex: ["teacher", "email"],
      key: "email",
    },
    {
      key: "opt",
      render: (_, r) => {
        return isAdmin(r) ? (
          <Button size="small" onClick={() => onAdd(r)}>
            Set as Admin
          </Button>
        ) : (
          <Button size="small" onClick={() => onDel(r)}>
            Remove Admin Role
          </Button>
        );
      },
    },
  ];

  return (
    <Modal title="Setup Org Admin" visible={true} maskClosable={false} onCancel={() => onClose()} footer={null}>
      <Table size="small" rowKey="id" columns={columns} dataSource={org.admins} />
    </Modal>
  );
};
